import { ICON__chevron_down } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_separator_labeled } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_separator_labeled';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { SEPARATOR__horizontal } from '@/pages/_base/separators/SEPARATOR__horizontal';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { cn } from '@/utils/utils_client';
import {
  ENUM__generation_output_type,
  ENUM_UTILS__generation_output_type,
} from '@shared/dto/generation/graph_invoke/_templates/_enums/ENUM__generation_output_type';
import React from 'react';

interface PROPS {
  is_readonly?: boolean;
}

export function G_DROPDOWN__generation_output_type({ is_readonly = false }: PROPS) {
  const dispatch = use_dispatch();

  /*
   * FIELDS
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_tools__output_type, g_general__ui_disabled } = use_slice_ui(['g_tools__output_type', 'g_general__ui_disabled']);

  const is_disabled = g_general__ui_disabled || is_readonly;

  /*
   * EVENTS
   */
  function on_item_selected(graph: ENUM__generation_output_type) {
    dispatch(LOCAL__ui_set_string({ key: 'g_tools__output_type', value: graph, valid_values: [] }));
  }

  /*
   *
   */

  function render_blocks() {
    let out = [];

    out.push(<SEPARATOR__horizontal key="separator_1" />);
    out.push(render_block('Image', '', ENUM_UTILS__generation_output_type.get_group_image()));
    out.push(render_block('Image Control', 'IMAGE_CONTROL', ENUM_UTILS__generation_output_type.get_group_image_control()));

    return out;
  }

  function render_block(title: string, prefix: string, items: ENUM__generation_output_type[]) {
    if (items.is_empty()) return null;

    return (
      <React.Fragment key={title}>
        <UI_PRIMITIVE__dropdown_menu_separator_labeled label={title} className="bg-bar px-2 text-component-item-foreground text-xs rounded-none" />

        {items.map(item => render_item(item, prefix))}
      </React.Fragment>
    );
  }

  function render_item(output_type: ENUM__generation_output_type, prefix: string) {
    return (
      <UI_PRIMITIVE__dropdown_menu_item
        key={`graph_template_${output_type}`}
        disabled={is_disabled}
        values_selected={[g_tools__output_type]}
        class_name_hovered_selected="bg-component-item-selected"
        className={cn('px-2 py-0.5 cursor-pointer text-xs bg-component text-component-item-foreground')}
        value={''}
        on_item_selected={() => void on_item_selected(output_type)}
      >
        {output_type.replaceAll(prefix, '').replaceAll('_', ' ').replaceAll('  ', '').trim()}
      </UI_PRIMITIVE__dropdown_menu_item>
    );
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  if (generation_current.is_stub()) return <PLACEHOLDER_bar_line />;

  return (
    <>
      <div className="flex flex-col min-h-6 h-6 gap-1 p-1 flex-shrink-0 border-b border-component-border">
        <UI_PRIMITIVE__dropdown_menu modal={false}>
          <UI_PRIMITIVE__dropdown_menu_trigger asChild>
            <UI_PRIMITIVE__button
              size="full-4"
              disabled={is_disabled}
              className={`info__dropdown_graph_template relative !text-bar-item-foreground justify-start text-xs rounded-sm truncate`}
              variant="outline-on-component"
            >
              <span className="w-full text-left px-2 truncate">Output: {g_tools__output_type.replaceAll('_', ' ')}</span>
              {!is_disabled && <ICON__chevron_down className="!size-2 absolute right-3 top-3.3" />}
            </UI_PRIMITIVE__button>
          </UI_PRIMITIVE__dropdown_menu_trigger>

          <UI_PRIMITIVE__dropdown_menu_content
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg dark:bg-component dark:border-component-border p-0"
            align="start"
            side="bottom"
            sideOffset={4}
          >
            {render_blocks()}
          </UI_PRIMITIVE__dropdown_menu_content>
        </UI_PRIMITIVE__dropdown_menu>
      </div>
    </>
  );
}
